/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ level: NonNullable<unknown> }} Today_Checkin_SentInputs */

const en_us2_today_checkin_sent = /** @type {(inputs: Today_Checkin_SentInputs) => LocalizedString} */ (i) => {
	if (i?.level === "mild") return /** @type {LocalizedString} */ (`Check-in sent · mild soreness`);
	if (i?.level === "moderate") return /** @type {LocalizedString} */ (`Check-in sent · moderate soreness`);
	if (i?.level === "intense") return /** @type {LocalizedString} */ (`Check-in sent · intense soreness`);
	return /** @type {LocalizedString} */ (`Check-in sent`)
	
};

const pt_br2_today_checkin_sent = /** @type {(inputs: Today_Checkin_SentInputs) => LocalizedString} */ (i) => {
	if (i?.level === "mild") return /** @type {LocalizedString} */ (`Check-in enviado · dor leve`);
	if (i?.level === "moderate") return /** @type {LocalizedString} */ (`Check-in enviado · dor moderada`);
	if (i?.level === "intense") return /** @type {LocalizedString} */ (`Check-in enviado · dor intensa`);
	return /** @type {LocalizedString} */ (`Check-in enviado`)
	
};

const es_419_today_checkin_sent = /** @type {(inputs: Today_Checkin_SentInputs) => LocalizedString} */ (i) => {
	if (i?.level === "mild") return /** @type {LocalizedString} */ (`Check-in enviado · dolor leve`);
	if (i?.level === "moderate") return /** @type {LocalizedString} */ (`Check-in enviado · dolor moderado`);
	if (i?.level === "intense") return /** @type {LocalizedString} */ (`Check-in enviado · dolor intenso`);
	return /** @type {LocalizedString} */ (`Check-in enviado`)
	
};

const pt_pt2_today_checkin_sent = /** @type {(inputs: Today_Checkin_SentInputs) => LocalizedString} */ (i) => {
	if (i?.level === "mild") return /** @type {LocalizedString} */ (`Check-in enviado · dor ligeira`);
	if (i?.level === "moderate") return /** @type {LocalizedString} */ (`Check-in enviado · dor moderada`);
	if (i?.level === "intense") return /** @type {LocalizedString} */ (`Check-in enviado · dor intensa`);
	return /** @type {LocalizedString} */ (`Check-in enviado`)
	
};

const fr_fr2_today_checkin_sent = /** @type {(inputs: Today_Checkin_SentInputs) => LocalizedString} */ (i) => {
	if (i?.level === "mild") return /** @type {LocalizedString} */ (`Bilan envoyé · courbatures légères`);
	if (i?.level === "moderate") return /** @type {LocalizedString} */ (`Bilan envoyé · courbatures modérées`);
	if (i?.level === "intense") return /** @type {LocalizedString} */ (`Bilan envoyé · courbatures intenses`);
	return /** @type {LocalizedString} */ (`Bilan envoyé`)
	
};

const de_de2_today_checkin_sent = /** @type {(inputs: Today_Checkin_SentInputs) => LocalizedString} */ (i) => {
	if (i?.level === "mild") return /** @type {LocalizedString} */ (`Check-in gesendet · leichter Muskelkater`);
	if (i?.level === "moderate") return /** @type {LocalizedString} */ (`Check-in gesendet · mittlerer Muskelkater`);
	if (i?.level === "intense") return /** @type {LocalizedString} */ (`Check-in gesendet · starker Muskelkater`);
	return /** @type {LocalizedString} */ (`Check-in gesendet`)
	
};

const it_it2_today_checkin_sent = /** @type {(inputs: Today_Checkin_SentInputs) => LocalizedString} */ (i) => {
	if (i?.level === "mild") return /** @type {LocalizedString} */ (`Check-in inviato · dolore lieve`);
	if (i?.level === "moderate") return /** @type {LocalizedString} */ (`Check-in inviato · dolore moderato`);
	if (i?.level === "intense") return /** @type {LocalizedString} */ (`Check-in inviato · dolore intenso`);
	return /** @type {LocalizedString} */ (`Check-in inviato`)
	
};

/**
* | level | output |
* | --- | --- |
* | "mild" | "Check-in sent · mild soreness" |
* | "moderate" | "Check-in sent · moderate soreness" |
* | "intense" | "Check-in sent · intense soreness" |
* | * | "Check-in sent" |
*
* @param {Today_Checkin_SentInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_checkin_sent = /** @type {((inputs: Today_Checkin_SentInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Checkin_SentInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_checkin_sent(inputs)
	if (locale === "es-419") return es_419_today_checkin_sent(inputs)
	if (locale === "pt-PT") return pt_pt2_today_checkin_sent(inputs)
	if (locale === "fr-FR") return fr_fr2_today_checkin_sent(inputs)
	if (locale === "de-DE") return de_de2_today_checkin_sent(inputs)
	if (locale === "it-IT") return it_it2_today_checkin_sent(inputs)
	return en_us2_today_checkin_sent(inputs)
});
export { today_checkin_sent as "today.checkin_sent" }